"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsModelForm = NewsModelForm;
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _moment = _interopRequireDefault(require("moment"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _avantagesGeovelo = _interopRequireDefault(require("../assets/images/news/avantages-geovelo.jpeg"));
var _avantagesVelotaf = _interopRequireDefault(require("../assets/images/news/avantages-velotaf.png"));
var _bienfaitsSante = _interopRequireDefault(require("../assets/images/news/bienfaits-sante.png"));
var _bienfaitsVelo = _interopRequireDefault(require("../assets/images/news/bienfaits-velo.png"));
var _bonsGestes = _interopRequireDefault(require("../assets/images/news/bons-gestes.png"));
var _comparatifGeovelo = _interopRequireDefault(require("../assets/images/news/comparatif-geovelo.png"));
var _impacts = _interopRequireDefault(require("../assets/images/news/impacts.png"));
var _starterPack = _interopRequireDefault(require("../assets/images/news/starter-pack.png"));
var _components = require("../components");
var _hooks = require("../hooks");
var _models = require("../models");
var _services = require("../services");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const now = (0, _moment.default)();
function NewsModelFormContent(_ref) {
  let {
    alternate,
    isSubmitting,
    models,
    selectModelId,
    selectedModelId,
    palette
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexWrap: "wrap",
    gap: 2
  }, models.map(newsPost => /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    key: newsPost.id,
    width: {
      xs: '100%',
      md: alternate ? 'calc((100% - 32px) / 3)' : 'calc((100% - 16px) / 2)'
    }
  }, /*#__PURE__*/_react.default.createElement(_ButtonBase2.default, {
    disabled: isSubmitting,
    onClick: () => selectModelId(newsPost.id),
    sx: {
      bgcolor: '#fff',
      borderRadius: 4,
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: `2px solid ${newsPost.id === selectedModelId ? palette.primary.main : '#e3e7ee'}`,
    borderRadius: 4,
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    maxWidth: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "stretch",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    maxWidth: "100%",
    overflow: "hidden",
    padding: 2
  }, newsPost.photo && /*#__PURE__*/_react.default.createElement("img", {
    src: newsPost.photo,
    width: 200
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    textAlign: "left",
    variant: "body2"
  }, newsPost.text)))))));
}
function NewsModelForm(_ref2) {
  let {
    alternate,
    prevPath,
    currentUser,
    currentPartner,
    geogroup,
    drawerWidth,
    redirectUrl,
    onCreated
  } = _ref2;
  const [isSubmitting, setSubmitting] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [models] = (0, _react.useState)([new _models.GeogroupNewsPost(1, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, now, 'Le vélo, allié de la planète : économie ressources, silence urbain, routes fluides. Zéro CO2, pollution minimale. Pédalons vers un avenir durable ! 🌍🚲', _bienfaitsVelo.default, null, null, 'manual'), new _models.GeogroupNewsPost(2, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, now, "Parfois, on n'a pas vraiment le choix… Mais pour un 10km, la question se pose ! 🤔🚲", _impacts.default, null, null, 'manual'), new _models.GeogroupNewsPost(3, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, now, "Le vélo libère l'esprit, améliore l'humeur et la concentration. En pédalant, le stress s'efface, l'anxiété s'apaise et la clarté mentale s'accroît. 🚴🧠", _bienfaitsSante.default, null, null, 'manual'), new _models.GeogroupNewsPost(4, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, now, 'Voici les accessoires incontournables pour votre nouveau vélo ! 🚲😎', _starterPack.default, null, null, 'manual'), new _models.GeogroupNewsPost(5, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, now, 'Changeons le monde par de petits gestes au quotidien : pédaler, baisser le chauffage, utiliser des contenants réutilisables… Chaque geste compte pour préserver notre planète. 🌍💚', _bonsGestes.default, null, null, 'manual'), new _models.GeogroupNewsPost(6, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, now, "Optez pour le vélotaf : gagnez en forme physique, réduisez le stress, contribuez à l'environnement et évitez les embouteillages. Une journée active, responsable et fluide. 🚲🍃", _avantagesVelotaf.default, null, null, 'manual'), new _models.GeogroupNewsPost(7, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, now, "Découvrez les 5 raisons d'utiliser Geovelo pour améliorer votre expérience à vélo ! 📱🚲", _avantagesGeovelo.default, null, null, 'manual'), new _models.GeogroupNewsPost(8, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, now, "Geovelo est le choix idéal pour les cyclistes qui souhaitent bénéficier d'un GPS adapté à leur pratique, avec des fonctionnalités supplémentaires pour faciliter leur expérience sur la route. 🚀👌", _comparatifGeovelo.default, null, null, 'manual')]);
  const [selectedModelId, selectModelId] = (0, _react.useState)(models[0].id);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const {
    palette
  } = (0, _styles.useTheme)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    return () => cancelPromises();
  }, []);
  async function handleSubmit() {
    if (!currentPartner || !geogroup || !currentUser) return;
    const model = models.find(_ref3 => {
      let {
        id
      } = _ref3;
      return id === selectedModelId;
    });
    if (!model) return;
    const {
      text,
      link
    } = model;
    setSubmitting(true);
    try {
      let photo;
      if (model.photo) {
        const res = await fetch(model.photo, {
          method: 'GET',
          headers: {
            'Content-Type': 'image/png'
          }
        });
        const blob = await res.blob();
        photo = new File([blob], model.photo.slice(model.photo.lastIndexOf('/') + 1));
      }
      await cancellablePromise(_services.GeogroupService.addNewsPost(geogroup.id, {
        text,
        link_url: link?.url,
        link_label: link?.url,
        photo: photo instanceof File ? photo : undefined,
        geo_group: geogroup.id
      }, currentPartner, true));
      enqueueSnackbar(t('commons.news_form.success_creation'));
      onCreated?.();
      navigate(redirectUrl || '/news');
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.news_form.server_error_creation'), {
          variant: 'error'
        });
        setSubmitting(false);
      }
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignSelf: "stretch",
    marginBottom: "58px"
  }, alternate ? /*#__PURE__*/_react.default.createElement(NewsModelFormContent, {
    alternate: true,
    isSubmitting: isSubmitting,
    models: models,
    palette: palette,
    selectedModelId: selectedModelId,
    selectModelId: selectModelId
  }) : /*#__PURE__*/_react.default.createElement(_Card2.default, {
    sx: {
      alignSelf: 'stretch',
      borderRadius: 4
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      padding: 3
    }
  }, /*#__PURE__*/_react.default.createElement(NewsModelFormContent, {
    isSubmitting: isSubmitting,
    models: models,
    palette: palette,
    selectedModelId: selectedModelId,
    selectModelId: selectModelId
  })))), /*#__PURE__*/_react.default.createElement(_components.StickyBar, {
    drawerWidth: drawerWidth
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "primary",
    component: _reactRouterDom.Link,
    disabled: isSubmitting,
    size: "large",
    startIcon: /*#__PURE__*/_react.default.createElement(_Close2.default, null),
    sx: {
      borderRadius: '8px !important'
    },
    to: prevPath,
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/_react.default.createElement(_components.Button, {
    disableElevation: true,
    color: "primary",
    disabled: isSubmitting,
    onClick: handleSubmit,
    size: "large",
    startIcon: isSubmitting ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_components.SendIcon, null),
    sx: {
      borderRadius: '8px !important'
    },
    variant: "contained"
  }, t('commons.news_form.actions.post')))));
}